module.exports = __webpack_public_path__ + "static/media/hostbanner.6213861e.png";